import noReferrer from './furillo/no-referrer.js';
import ajaxPartials from './furillo/ajax-partials.js';
import cookieHelper from './furillo/cookie-helper.js';
import TagFilter from './furillo/tag-filter.js';
import { navbarDropdownOverrides } from './furillo/navigation.js';
import { eventFilters } from './furillo/event-filters.js';
/*import { offcanvasOverrides } from './furillo/offcanvas.js';*/
import imageGallery from './furillo/image-gallery.js';
import aos from '../../vendor/aos/dist/aos.js';
import popperjs from '../../vendor/@popperjs/core/dist/cjs/popper.js';
import lazyframe from '../../vendor/lazyframe/dist/lazyframe.min.js';
import Collapse from '../../vendor/bootstrap/js/dist/collapse.js';
import Offcanvas from '../../vendor/bootstrap/js/dist/offcanvas.js';
import Tooltip from '../../vendor/bootstrap/js/dist/tooltip.js';

export default document.addEventListener('DOMContentLoaded', function () {

    function initTooltip(container) {
        // Enable tooltips    
        const tooltips = container.querySelectorAll('[data-bs-toggle="tooltip"]');
        if (tooltips && tooltips.length > 0) {
            const tooltipList = [...tooltips].map(element => new Tooltip(element))
        }
    }

    initTooltip(document);

    // Add noreferrer to links
    noReferrer(document.querySelector('body'));

    // Modify default behaviour of navbar
    navbarDropdownOverrides(document.querySelector('#site > header nav.navbar'));
    /*offcanvasOverrides(document.querySelector('#site > header nav.navbar'));*/

    // Init the event filters (if present)
    eventFilters(document.querySelector('body.event-list-page section.event-search'));

    // Init ajax partials
    ajaxPartials.init(document.querySelector('body'), function (container) {

        if (!container || container.getAttribute('id') !== 'event-search-result')
            return;

        initTooltip(container);       
    });

    // Init animations    
    aos.init({
        offset: 0,
        duration: 600,
        easing: 'ease-in-out',
        delay: 100,
        once: true
    });   

    // Check for iframes and load them with lazy frame
    const frames = document.querySelectorAll('.lazyframe');
    if (frames && frames.length > 0) {
        lazyframe(frames);
    }

    // Check for image blocks and add possibility to open as modal
    const images = document.querySelectorAll('.block-image a.open-image-modal');
    if (images && images.length > 0) {
        images.forEach(image => {
            image.setAttribute('data-bs-toggle', 'modal');
            image.setAttribute('data-bs-target', '#image-gallery-modal');
        });
    }
    imageGallery(document.querySelector('#image-gallery-modal'));

    // Check for lists with tag filters and add filtering
    const filteredLists = document.querySelectorAll('.published-content-list .tag-filters');
    if (filteredLists && filteredLists.length > 0) {
        filteredLists.forEach(list => {
            const filter = new TagFilter(list);
        });
    }

    
    
});

